import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { indicatorInfoObj } from '../../store/slices/modelSurfaceSlice';
import './modelSurfaceTable.css';

export default function IndicatorTable() {
  const indicatorInfo = useSelector(indicatorInfoObj);
  const [indicatorObj, setIndicatorObj] = useState({});

  useEffect(() => {
    if (Object.keys(indicatorInfo).length) {
      setIndicatorObj(indicatorInfo);
    }
  }, [indicatorInfo]);

  const TABLE_KEYS = [
    { tKey: 'Indicator', objKey: 'Label' },
    { tKey: 'Measure', objKey: 'Label' },
    { tKey: 'Definition', objKey: 'Definition' },
    { tKey: 'Denominator', objKey: 'Denominator' },
    { tKey: 'Group', objKey: 'group' },
    { tKey: 'Universe', objKey: 'Level3' },
    { tKey: 'Type', objKey: 'IndicatorType' },
    { tKey: 'Decimals', objKey: 'NumberScale' },
    { tKey: 'Indicator ID', objKey: 'indicator_id' },
    { tKey: 'SDRID', objKey: 'sdr_id' },
    { tKey: 'API Link', objKey: 'api_link' },
  ];

  return (
    <table>
      {Object.keys(indicatorObj).length &&
        TABLE_KEYS.map((tableKey) => {
          return (
            <tr className='indicator-tablerow'>
              <td className='indicator-tabledata'>{tableKey.tKey}</td>
              <td
                className='indicator-tabledata'
                style={tableKey.objKey === 'api_link' ? { overflowWrap: 'anywhere' } : {}}
              >
                {tableKey.objKey === 'api_link' ? (
                  <a href={indicatorObj[tableKey.objKey]} target='_blank'>
                    {indicatorObj[tableKey.objKey]}
                  </a>
                ) : (
                  indicatorObj[tableKey.objKey]
                )}
              </td>
            </tr>
          );
        })}
    </table>
  );
}
